import React from 'react'
import { TrackingContainer, type TrackingContainerProps } from '@mc/visibility'

type FeatureProps = TrackingContainerProps & {
  className?: string
  children: React.ReactNode
}

export const Feature = ({
  className = '',
  children,
  ...props
}: FeatureProps) => (
  <TrackingContainer
    role='row'
    className={`row no-gutters d-flex justify-content-between ${className}`}
    {...props}
  >
    {children}
  </TrackingContainer>
)
